import script from "./YearSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./YearSelector.vue?vue&type=script&setup=true&lang=js"

import "./YearSelector.vue?vue&type=style&index=0&id=3ea58684&scoped=true&lang=css"
import "./YearSelector.vue?vue&type=style&index=1&id=3ea58684&lang=scss"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ea58684"]])

export default __exports__